import React, { memo } from 'react';
import styles from './ProjectCard.module.scss';

import { SFCard } from 'sfui';
import { isEqualObject } from 'ui-smartforce-settings';

import { ProjectValue } from '../../../../../../Models/ProjectValue';
import { ProjectMap } from './ProjectMap/ProjectMap';
import { ProjectCardHeader } from './ProjectCardHeader/ProjectCardHeader';
import { ProjectCardInfo } from './ProjectCardInfo/ProjectCardInfo';
import { UseProjectCard } from './hooks/UseProjectCard';

export interface ProjectCardProps {
  project: ProjectValue;
}

export const ProjectCard = memo(
  function ({
    project
  }: ProjectCardProps): React.ReactElement<ProjectCardProps> {
    const {
      isSeeRecentReportsBtnDisabled,
      onSeeDateRowReports,
      onSeeRecentReports
    } = UseProjectCard({ project });

    return (
      <SFCard sfElevation={2} containerClassName={styles.projectCard}>
        {!!project && (
          <div className={styles.projectCardContainer}>
            <ProjectMap className={styles.leftMap} areas={project.areas} />

            <div className={styles.projectCardContent}>
              <ProjectCardHeader
                className={styles.header}
                name={project.name}
                tags={project.tags}
                isButtonDisabled={isSeeRecentReportsBtnDisabled}
                onSeeRecentReports={onSeeRecentReports}
              />

              <ProjectMap className={styles.topMap} areas={project.areas} />

              <ProjectCardInfo
                className={styles.info}
                project={project}
                onSeeDateRowReports={onSeeDateRowReports}
              />
            </div>
          </div>
        )}
      </SFCard>
    );
  },
  (prevProps: ProjectCardProps, nextProps: ProjectCardProps) =>
    isEqualObject(prevProps.project, nextProps.project)
);
